import React from "react";
import DocumentLifeCyclePill from "../../../document/components/DocumentLifeCyclePill";
import { newLineToBr } from "../../../utilities";
import { tryParseJson } from "../../../utilities/jsonUtils";

interface CardProps {
  activity: server.dto.InvoiceActivity
}

const InvoiceActivityCardContent = (props: CardProps) => {
  const card = Switch(props);

  if (card == null) return <></>;

  return <div className="margin-left">
    {card}
  </div>;
};

const Switch = (props: CardProps) => {
  const { action } = props.activity;
  if (action.value === "lifeCycleToDraft") return <DocumentLifeCyclePill isInvoice value="draft" />;
  if (action.value === "lifeCycleToReview") return <DocumentLifeCyclePill isInvoice value="review" />;
  if (action.value === "lifeCycleToOutstanding") return <DocumentLifeCyclePill isInvoice value="pending" />;
  if (action.value === "lifeCycleToCompleted") return <DocumentLifeCyclePill isInvoice value="completed" />;

  if (action.value === "checklistItemApproved") return <ChecklistApproved activity={props.activity} />;
  if (action.value === "checklistItemDeclined") return <ChecklistDeclined activity={props.activity} />;

  return <Regular activity={props.activity} />;
};

const ChecklistApproved = (props: CardProps) => {
  const { content } = props.activity;

  if (content == null) return null;

  return <div className="flex">
    <div className="margin-right"><i className="icon-check green small"></i></div>
    <div className="grow1">
      {newLineToBr(content)}
    </div>
  </div>;
};

const ChecklistDeclined = (props: CardProps) => {
  const dto = tryParseJson<server.dto.ChecklistDeclinedActivityContent>(props.activity.content);

  if (dto == null) return null;

  return <>
    <div className="flex">
      <div className="margin-right"><i className="icon-x red small" style={{ fontSize: 13 }}></i></div>
      <div className="grow1">
        {newLineToBr(dto.question)}
      </div>
    </div>

    {(dto.reason != null) && <div className="padding lightred-bg margin-top-small s1_small">
      {newLineToBr(dto.reason)}
    </div>}
  </>;
};

const Regular = (props: CardProps) => {
  const { content } = props.activity;

  if (content == null) return null;

  return <div className="flex">
    <div style={{ width: 3 }} className="gray"></div>
    <div className="grow1 padding-small">
      {newLineToBr(content)}
    </div>
  </div>;
};

export default InvoiceActivityCardContent;